import { render } from "./NotificationsButton.vue?vue&type=template&id=0ef89490&scoped=true"
import script from "./NotificationsButton.vue?vue&type=script&lang=js"
export * from "./NotificationsButton.vue?vue&type=script&lang=js"

import "./NotificationsButton.vue?vue&type=style&index=0&id=0ef89490&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef89490"],['__file',"src/common/components/modals/Notifications/NotificationsButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ef89490"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ef89490', __exports__)) {
    api.reload('0ef89490', __exports__)
  }
  
  module.hot.accept("./NotificationsButton.vue?vue&type=template&id=0ef89490&scoped=true", () => {
    api.rerender('0ef89490', render)
  })

}


export default __exports__